export const Types = {
    "Normal": {
        "NO": 1,
        "EN": "Normal",
        "JP": "ノーマル",
        "FR": "Normal",
        "DE": "Normal",
        "ES": "Normal",
        "IT": "Normale",
        "KOR": "노말",
        "CHS": "一般",
        "CHT": "一般",
        "SPRITE": "/images/types/normal.png"
    },
    "Fighting": {
        "NO": 2,
        "EN": "Fighting",
        "JP": "かくとう",
        "FR": "Combat",
        "DE": "Kampf",
        "ES": "Lucha",
        "IT": "Lotta",
        "KOR": "격투",
        "CHS": "格斗",
        "CHT": "格鬥",
        "SPRITE": "/images/types/fighting.png"
    },
    "Flying": {
        "NO": 3,
        "EN": "Flying",
        "JP": "ひこう",
        "FR": "Vol",
        "DE": "Flug",
        "ES": "Volador",
        "IT": "Volante",
        "KOR": "비행",
        "CHS": "飞行",
        "CHT": "飛行",
        "SPRITE": "/images/types/flying.png"
    },
    "Poison": {
        "NO": 4,
        "EN": "Poison",
        "JP": "どく",
        "FR": "Poison",
        "DE": "Gift",
        "ES": "Veneno",
        "IT": "Veleno",
        "KOR": "독",
        "CHS": "毒",
        "CHT": "毒",
        "SPRITE": "/images/types/poison.png"
    },
    "Ground": {
        "NO": 5,
        "EN": "Ground",
        "JP": "じめん",
        "FR": "Sol",
        "DE": "Boden",
        "ES": "Tierra",
        "IT": "Terra",
        "KOR": "땅",
        "CHS": "地面",
        "CHT": "地面",
        "SPRITE": "/images/types/ground.png"
    },
    "Rock": {
        "NO": 6,
        "EN": "Rock",
        "JP": "いわ",
        "FR": "Roche",
        "DE": "Gestein",
        "ES": "Roca",
        "IT": "Roccia",
        "KOR": "바위",
        "CHS": "岩石",
        "CHT": "岩石",
        "SPRITE": "/images/types/rock.png"
    },
    "Bug": {
        "NO": 7,
        "EN": "Bug",
        "JP": "むし",
        "FR": "Insecte",
        "DE": "Käfer",
        "ES": "Bicho",
        "IT": "Coleottero",
        "KOR": "벌레",
        "CHS": "虫",
        "CHT": "蟲",
        "SPRITE": "/images/types/bug.png"
    },
    "Ghost": {
        "NO": 8,
        "EN": "Ghost",
        "JP": "ゴースト",
        "FR": "Spectre",
        "DE": "Geist",
        "ES": "Fantasma",
        "IT": "Spettro",
        "KOR": "고스트",
        "CHS": "幽灵",
        "CHT": "幽靈",
        "SPRITE": "/images/types/ghost.png"
    },
    "Steel": {
        "NO": 9,
        "EN": "Steel",
        "JP": "はがね",
        "FR": "Acier",
        "DE": "Stahl",
        "ES": "Acero",
        "IT": "Acciaio",
        "KOR": "강철",
        "CHS": "钢",
        "CHT": "鋼",
        "SPRITE": "/images/types/steel.png"
    },
    "Fire": {
        "NO": 10,
        "EN": "Fire",
        "JP": "ほのお",
        "FR": "Feu",
        "DE": "Feuer",
        "ES": "Fuego",
        "IT": "Fuoco",
        "KOR": "불꽃",
        "CHS": "火",
        "CHT": "火",
        "SPRITE": "/images/types/fire.png"
    },
    "Water": {
        "NO": 11,
        "EN": "Water",
        "JP": "みず",
        "FR": "Eau",
        "DE": "Wasser",
        "ES": "Agua",
        "IT": "Acqua",
        "KOR": "물",
        "CHS": "水",
        "CHT": "水",
        "SPRITE": "/images/types/water.png"
    },
    "Grass": {
        "NO": 12,
        "EN": "Grass",
        "JP": "くさ",
        "FR": "Plante",
        "DE": "Pflanze",
        "ES": "Planta",
        "IT": "Erba",
        "KOR": "풀",
        "CHS": "草",
        "CHT": "草",
        "SPRITE": "/images/types/grass.png"
    },
    "Electric": {
        "NO": 13,
        "EN": "Electric",
        "JP": "でんき",
        "FR": "Électrik",
        "DE": "Elektro",
        "ES": "Eléctrico",
        "IT": "Elettro",
        "KOR": "전기",
        "CHS": "电",
        "CHT": "電",
        "SPRITE": "/images/types/electric.png"
    },
    "Psychic": {
        "NO": 14,
        "EN": "Psychic",
        "JP": "エスパー",
        "FR": "Psy",
        "DE": "Psycho",
        "ES": "Psíquico",
        "IT": "Psico",
        "KOR": "에스퍼",
        "CHS": "超能力",
        "CHT": "超能力",
        "SPRITE": "/images/types/psychic.png"
    },
    "Ice": {
        "NO": 15,
        "EN": "Ice",
        "JP": "こおり",
        "FR": "Glace",
        "DE": "Eis",
        "ES": "Hielo",
        "IT": "Ghiaccio",
        "KOR": "얼음",
        "CHS": "冰",
        "CHT": "冰",
        "SPRITE": "/images/types/ice.png"
    },
    "Dragon": {
        "NO": 16,
        "EN": "Dragon",
        "JP": "ドラゴン",
        "FR": "Dragon",
        "DE": "Drache",
        "ES": "Dragón",
        "IT": "Drago",
        "KOR": "드래곤",
        "CHS": "龙",
        "CHT": "龍",
        "SPRITE": "/images/types/dragon.png"
    },
    "Dark": {
        "NO": 17,
        "EN": "Dark",
        "JP": "あく",
        "FR": "Ténèbres",
        "DE": "Unlicht",
        "ES": "Siniestro",
        "IT": "Buio",
        "KOR": "악",
        "CHS": "恶",
        "CHT": "惡",
        "SPRITE": "/images/types/dark.png"
    },
    "Fairy": {
        "NO": 18,
        "EN": "Fairy",
        "JP": "フェアリー",
        "FR": "Fée",
        "DE": "Fee",
        "ES": "Hada",
        "IT": "Folletto",
        "KOR": "페어리",
        "CHS": "妖精",
        "CHT": "妖精",
        "SPRITE": "/images/types/fairy.png"
    }
}
